import { Container, Row, Col, Button } from "react-bootstrap";
import { CalendarCheck, Clock, Star } from "lucide-react";
import heroBg from "../assets/hero-bg.jpg";

const HeroSection = () => {
  const scrollToBooking = () => {
    const element = document.getElementById("agendamento");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToServices = () => {
    const element = document.getElementById("servicos");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section 
      className="hero-section d-flex align-items-center"
      style={{ backgroundImage: `url(${heroBg})` }}
    >
      <div className="hero-overlay" />
      
      <Container className="position-relative" style={{ zIndex: 10, paddingTop: "100px" }}>
        <Row className="justify-content-center">
          <Col lg={10} xl={8} className="text-center">
            {/* Badge */}
            <div className="d-inline-flex align-items-center gap-2 bg-secondary-custom rounded-pill px-3 py-2 mb-4 animate-fade-in">
              <Star size={16} className="text-primary-custom" fill="#0d9488" />
              <span className="small fw-medium text-primary-custom">
                +500 clientes satisfeitos
              </span>
            </div>

            {/* Title */}
            <h1 className="display-4 fw-bold mb-4 animate-slide-up">
              Agende seu horário de forma{" "}
              <span className="text-primary-custom">simples e rápida</span>
            </h1>

            {/* Subtitle */}
            <p className="lead text-muted-custom mb-5 animate-slide-up" style={{ animationDelay: "0.1s" }}>
              Oferecemos os melhores serviços com profissionais qualificados. 
              Reserve seu horário online em poucos cliques.
            </p>

            {/* CTA Buttons */}
            <div className="d-flex flex-column flex-sm-row align-items-center justify-content-center gap-3 mb-5 animate-slide-up" style={{ animationDelay: "0.2s" }}>
              <Button className="btn-primary-custom btn-hero d-flex align-items-center gap-2" onClick={scrollToBooking}>
                <CalendarCheck size={20} />
                Fazer Agendamento
              </Button>
              <Button className="btn-outline-custom btn-hero" onClick={scrollToServices}>
                Ver Serviços
              </Button>
            </div>

            {/* Stats */}
            <Row className="g-3 animate-slide-up" style={{ animationDelay: "0.3s" }}>
              <Col xs={6} md={4}>
                <div className="stats-card">
                  <div className="fs-2 fw-bold text-primary-custom mb-1">98%</div>
                  <div className="small text-muted-custom">Satisfação</div>
                </div>
              </Col>
              <Col xs={6} md={4}>
                <div className="stats-card">
                  <div className="fs-2 fw-bold text-primary-custom mb-1">5+</div>
                  <div className="small text-muted-custom">Anos de experiência</div>
                </div>
              </Col>
              <Col xs={12} md={4}>
                <div className="stats-card">
                  <div className="d-flex align-items-center justify-content-center gap-2 fs-2 fw-bold text-primary-custom mb-1">
                    <Clock size={28} />
                    24h
                  </div>
                  <div className="small text-muted-custom">Agendamento online</div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HeroSection;